// src/pages/wartungsprotokoll/WartungsprotokollSeite11.jsx

import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";

export default function WartungsprotokollSeite11({ form, setForm }) {

const [showZusatz1, setShowZusatz1] = useState(false);
const [showZusatz2, setShowZusatz2] = useState(false);

  if (
    !form ||
    !form.pruefungMSsicht ||
    !form.zusatzMSsicht ||
    !form.sonstiges ||
    !form.zusatzSonstiges
  ) return null;


  const updateRow = (section, index, field) => {
    setForm(prev => {
      const updated = [...prev[section]];
      updated[index][field] = !updated[index][field];
      return { ...prev, [section]: updated };
    });
  };

  const updateZusatz = (table, index, field, value) => {
    setForm(prev => {
      const updated = [...prev[table]];
      updated[index][field] = value;
      return { ...prev, [table]: updated };
    });
  };

  const rows15 = [
    "15.1 Sichtprüfung der Trafostation durchgeführt, ohne Beanstandungen",
    "15.2 Sichtprüfung der Übergabestation durchgeführt, ohne Beanstandungen",
    "15.3 Die Anzugsmomente aller Schrauben sind richtig (Kabelanschlüsse)",
    "15.4 Reinigung Station / Lüftungswege u.ä. (ohne Abschaltung) ausgeführt"
  ];

  const rows16 = [
    "16.1 Warnschilder für PV-Anlage und Komp. vorhanden und in Ordnung",
    "16.2 Brandschutzkonzept ist vorhanden und aktuell (Pläne, usw.)",
    "16.3 Brandschutzmaßnahmen i. O. (Feuerlöscher, Schlüssel, usw.)",
    "16.4 Blitzschutzkonzept vorhanden, Maßnahmen in Ordnung"
  ];

  return (
    
    <div className="p-6 text-sm">
      <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
      <h2 style={{ fontWeight: "bold" }}>15 Sichtprüfung Mittelspannungsanlagen</h2>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
          <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
        <tbody>
          {rows15.map((text, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                {text}
              </td>

              {/* Ja */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungMSsicht?.[idx]?.ja || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungMSsicht || [])];
                      list[idx] = { ja: true, nein: false, nz: false };
                      return { ...f, pruefungMSsicht: list };
                    })
                  }
                />
              </td>

              {/* Nein */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungMSsicht?.[idx]?.nein || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungMSsicht || [])];
                      list[idx] = { ja: false, nein: true, nz: false };
                      return { ...f, pruefungMSsicht: list };
                    })
                  }
                />
              </td>

              {/* n.z. */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungMSsicht?.[idx]?.nz || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungMSsicht || [])];
                      list[idx] = { ja: false, nein: false, nz: true };
                      return { ...f, pruefungMSsicht: list };
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>


             {/* Button for ZUSATZ-TABELLE #1 */}
                <Box mb={3} mt={4}>
            
                    <Button
                      onClick={() => setShowZusatz1(!showZusatz1)}
                      colorScheme="blue"
                      borderRadius="lg"
                    >
                      {showZusatz1 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
                    </Button>
            
               </Box>


      {/* Zusatz-Tabelle #1 */}
      {showZusatz1 && (
        <>
      <table className="w-full mb-10 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Zu Punkt</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Bemerkungen/Mängel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Standort</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Plan</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Bild-Nr.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Beh.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>n. Beh.</th>
          </tr>
        </thead>

        <tbody>
          {form.zusatzMSsicht.map((row, idx) => (
            <tr key={idx}>
              {["zupunkt", "bemerkung", "standort"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px" }}>
                  <input
                    type="text"
                    value={row[field]}
                    onChange={e => updateZusatz("zusatzMSsicht", idx, field, e.target.value)}
                    style={{ width: "100%", border: "none", background: "#f7f7fb" }}
                  />
                </td>
              ))}

              <td style={{ border: "1px solid #ccc", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.plan}
                  onChange={() => updateZusatz("zusatzMSsicht", idx, "plan", !row.plan)}
                />
              </td>

              <td style={{ border: "1px solid #ccc" }}>
                <input
                  type="text"
                  value={row.bildnr}
                  onChange={e => updateZusatz("zusatzMSsicht", idx, "bildnr", e.target.value)}
                  style={{ width: "100%", border: "none", background: "#f7f7fb" }}
                />
              </td>

              {["beh", "nbeh"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row[field]}
                    onChange={() => updateZusatz("zusatzMSsicht", idx, field, !row[field])}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
          </>
       )}
       </Box>

      <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
      {/* SECTION 16 */}
      <h2 style={{ fontWeight: "bold" }}>16 Sonstiges</h2>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
          <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
        <tbody>
          {rows16.map((text, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                {text}
              </td>

              {/* Ja */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
               
                <input
                  type="checkbox"
                  checked={form.sonstiges?.[idx]?.ja || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.sonstiges || [])];
                      list[idx] = { ja: true, nein: false, nz: false };
                      return { ...f, sonstiges: list };
                    })
                  }
                />
              </td>

              {/* Nein */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.sonstiges?.[idx]?.nein || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.sonstiges || [])];
                      list[idx] = { ja: false, nein: true, nz: false };
                      return { ...f, sonstiges: list };
                    })
                  }
                />
              </td>

              {/* n.z. */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.sonstiges?.[idx]?.nz || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.sonstiges || [])];
                      list[idx] = { ja: false, nein: false, nz: true };
                      return { ...f, sonstiges: list };
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

          {/* Button for Zusatz-Tabelle #2 */}
          <Box mb={3} mt={4}>
            
                    <Button
                      onClick={() => setShowZusatz2(!showZusatz2)}
                      colorScheme="blue"
                      borderRadius="lg"
                    >
                      {showZusatz2 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
                    </Button>
            
                    </Box>

      {/* Zusatz-Tabelle #2 */}
      
       {showZusatz2 && (
        <>

      <table className="w-full mb-10 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Zu Punkt</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Bemerkungen/Mängel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Standort</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Plan</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Bild-Nr.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Beh.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>n. Beh.</th>
          </tr>
        </thead>

        <tbody>
          {form.zusatzSonstiges.map((row, idx) => (
            <tr key={idx}>
              {["zupunkt", "bemerkung", "standort"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px" }}>
                  <input
                    type="text"
                    value={row[field]}
                    onChange={e => updateZusatz("zusatzSonstiges", idx, field, e.target.value)}
                    style={{ width: "100%", border: "none", background: "#f7f7fb" }}
                  />
                </td>
              ))}

              <td style={{ border: "1px solid #ccc", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.plan}
                  onChange={() => updateZusatz("zusatzSonstiges", idx, "plan", !row.plan)}
                />
              </td>

              <td style={{ border: "1px solid #ccc" }}>
                <input
                  type="text"
                  value={row.bildnr}
                  onChange={e => updateZusatz("zusatzSonstiges", idx, "bildnr", e.target.value)}
                  style={{ width: "100%", border: "none", background: "#f7f7fb" }}
                />
              </td>

              {["beh", "nbeh"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row[field]}
                    onChange={() => updateZusatz("zusatzSonstiges", idx, field, !row[field])}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
        </>
       )}
            
       </Box>       
    </div>
  );
}